import { useRef } from 'react';
import { Box, Checkbox } from '@chakra-ui/react';

interface OrderHoverCheckboxProps {
    orderId: string;
    isChecked: boolean;
    rowIndex: number;
    onToggle: (orderId: string, rowIndex: number, shiftKey: boolean) => void;
}

const OrderHoverCheckbox = ({
    orderId,
    isChecked,
    rowIndex,
    onToggle,
}: OrderHoverCheckboxProps) => {
    const shiftKeyRef = useRef(false);

    return (
        <Box
            className="order-row-checkbox"
            opacity={isChecked ? 1 : 0}
            pointerEvents={isChecked ? 'auto' : 'none'}
            transition="opacity 150ms ease"
            display="flex"
            alignItems="center"
            justifyContent="center"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
        >
            <Checkbox
                aria-label={`Select order ${orderId}`}
                isChecked={isChecked}
                size="sm"
                sx={{
                    '& .chakra-checkbox__control': {
                        width: '14px',
                        height: '14px',
                    },
                    '& .chakra-checkbox__icon': {
                        fontSize: '9px',
                    },
                }}
                onMouseDown={(e) => {
                    e.stopPropagation();
                    shiftKeyRef.current = e.shiftKey;
                }}
                onChange={() => {
                    onToggle(orderId, rowIndex, shiftKeyRef.current);
                }}
            />
        </Box>
    );
};

export default OrderHoverCheckbox;
